import { FindSalesDocumentTemplateDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSalesDocumentTemplate = (salesDocumentTemplateId: number, isOpen: boolean) => {
  const {
    data: foundData,
    loading,
    error,
  } = useQuery(FindSalesDocumentTemplateDocument, {
    variables: { id: salesDocumentTemplateId },
    skip: !isOpen,
  })

  const salesDocumentTemplate = foundData?.finance?.salesDocumentTemplate

  return {
    salesDocumentTemplate,
    loading,
    error,
    notFound: !loading && !error && !salesDocumentTemplate,
  }
}
